import Can from './Can'
export default Can